import { render, staticRenderFns } from "./RelatedQuestionManagement.vue?vue&type=template&id=cd917476&scoped=true"
import script from "./RelatedQuestionManagement.vue?vue&type=script&lang=js"
export * from "./RelatedQuestionManagement.vue?vue&type=script&lang=js"
import style0 from "./RelatedQuestionManagement.vue?vue&type=style&index=0&id=cd917476&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd917476",
  null
  
)

export default component.exports